import React from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  Paper
} from "@material-ui/core";
import { Link } from "react-router-dom";
import {
  UPLOAD,
} from '../../utils/constants';


function IntroPage() {
  return (
    <>
    <Paper spacing={4} style={{minHeight: '100vh',minWidth: '50vw'}}>
      <Grid container spacing={6}>
        <Grid item xs={2} md={3}>
          <Paper />
        </Grid>
        <Grid item xs={8} md={6}>
          <Box mt={20}>
              <Typography variant="h1" gutterBottom>
                How To Get Started
              </Typography>
              <br />
              <Typography variant="h6">
                Create page to upload *.mp4 video file.
              </Typography>
              <br />
              <Typography variant="h6">
                We only support English content right now. System will extract audio file and transcribe it into txt.
              </Typography>
              <br />
              <Typography variant="h6">
                We support analytics, you can view them in Dashboard once you have created tasks
              </Typography>
          </Box>
        </Grid>
        <Grid item xs={2} md={3}>
          <Paper />
        </Grid>
      </Grid>

      <Grid container spacing={6}>
              <Grid item xs={3} md={5}>
                <Paper />
              </Grid>
              <Grid item xs={6} md={2}>
                <Box mt={4}>
                  <Button
                    component={Link}
                    variant="contained"
                    color="primary"
                    to={UPLOAD}
                  >
                    Get Started
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={3} md={5}>
                <Paper />
              </Grid>
            </Grid>
    </Paper>
    </>
  );
}


export default IntroPage;